<template>
    <span>
        <lembretemedicacaolistagem></lembretemedicacaolistagem>
    </span>
</template>

<script>
import Lembretemedicacaolistagem from '@/components/Lembrete-Medicacao-Listagem';

export default {
    name: 'cadlembretemedicacaolistagem',
    components: {
        Lembretemedicacaolistagem
    }
};
</script>